<!--
 * @Author: 邱扬
 * @LastEditors: 邱扬
 * @description: page description
 * @Date: 2021-09-13 17:12:23
 * @LastEditTime: 2021-09-24 15:00:44
-->
<template>
  <div class="select-country">
    <van-cell title="Country/Region" is-link class="app-reset" @click="selectCoutry">
      <template #value>
        <div v-if="region" class="country-right">
          <Region :region="region" />
        </div>
        <span v-else-if="pageType==='keyword'" style="color: #999;">Click Add Country</span>
        <span v-else>All</span>
        
      </template>
    </van-cell>
    <hr class="select-status-bottom">
    <transition name="slide">
      <SelectCountry ref="contryRef" :platform="platform" @getCountry="changeCountry" :order-type="orderType" />
    </transition>
  </div>
</template>

<script>
import { ref } from 'vue'
import Region from 'components/Region'
import { useStore } from 'vuex'
export default {
  name: 'SelectCountryDetail',
  //import 引入组件
  components: {
    Region
  },
  props:{
    region:{
      type:String,
      default:null
    },
    platform:{
      type:Number,
      default:null
    },
    pageType:{
      type:String,
      default:null
    },
    orderType:{
      type:String,
      default:null
    }
  },
  emits: {'getSelectCountry': null},
  setup(props,{emit}) {
    const store=useStore()
    // 选择国家
    const contryRef = ref(null)
    const selectCoutry = () => {
      contryRef.value.openBox()
      //刷新平台对应国家
    }
    const changeCountry = (val) => {
      if(props.pageType==='order'){
        store.commit('order/setOrderRegion',val.sign||val)
      }
      emit('getSelectCountry',val.sign||val)
    }
    // 选择your apps
    return {
      contryRef,
      selectCoutry,
      changeCountry
    }
  },
}
</script>

<style scoped lang="scss">
.select-country {
  .van-cell {
    padding: 8px 10px;

    &::after {
      left: 10px;
      right: 10px;
    }

    :deep(.van-cell__title) {
      color: #1e183f;
      font-weight: bold;
    }

    :deep(.van-cell__value) {
      font-size: 13px;
      flex: inherit;

      & > span {
        color: #1e183f;
      }
    }
  }

  .select-status-bottom {
    height: 0;
    border: none;
    position: absolute;
    border-top: 1px solid #ebeef5;
  }
}
</style>
